import Vue from "vue";
import AlertDialog from "@/components/AlertDialog.vue";
import vuetify from "./vuetify";

let instance = null;

function getInstance() {
  if (!instance) {
    const AlertConstructor = Vue.extend(AlertDialog);
    instance = new AlertConstructor({ vuetify });
    const el = document.createElement("div");
    document.body.appendChild(el);
    instance.$mount(el);
  }
  return instance;
}

/**
 * Standalone alert function for use outside Vue components (stores, router, utils).
 * Usage:
 *   import { showAlert } from "@/plugins/alertDialog";
 *   showAlert("Something happened");
 *   showAlert({ title: "Error", message: "Details...", color: "error" });
 */
export function showAlert(options) {
  if (typeof options === "string") {
    options = { message: options };
  }
  return getInstance().open(options);
}

const AlertDialogPlugin = {
  install(Vue) {
    /**
     * Usage in components:
     *   await this.$alert("Something happened");
     *   await this.$alert({ title: "Error", message: "Details...", color: "error" });
     */
    Vue.prototype.$alert = function (options) {
      return showAlert(options);
    };
  },
};

Vue.use(AlertDialogPlugin);

export default AlertDialogPlugin;
